import axios from "../axiosInstance";

class ProfileService {
  async listProfiles() {
    return await axios.get("profile");
  }
}

export default new ProfileService();
